import { View, ViewModel, ViewModelMessage } from "binder"
import { MessageBoxViewModel } from "../messageBox/messageBox-viewModel";
import { WindowContainerViewModel, WindowViewModel } from "./windowContainer-viewModel"

export class WindowContainerView extends View<WindowContainerViewModel>{
    GetViewUniqueId(): string {
        return "V-652E83D2-1D8B-4FE8-ABFB-AB99EA82ECF9"
    }
    loadHtml(): string {
        let element = require('./windowContainer.html').default;
        let style = require('./windowContainer.less');
        return element;
    }
    constructor() {
       super();
    }

    public set window(v: WindowViewModel) { this._window = v; } public get window(): WindowViewModel { return this._window;} private _window: WindowViewModel;
    public set isShowingMessageBox(v: boolean) { this._isShowingMessageBox = v; } public get isShowingMessageBox(): boolean { return this._isShowingMessageBox;} private _isShowingMessageBox: boolean;
    public set msgViewModel(v: MessageBoxViewModel) { this._msgViewModel = v; } public get msgViewModel(): MessageBoxViewModel { return this._msgViewModel;} private _msgViewModel: MessageBoxViewModel;
    public set canRefresh(v: boolean) { this._canRefresh = v; } public get canRefresh(): boolean { return this._canRefresh;} private _canRefresh: boolean;
    
    refresh(){
        this.dataContext.refresh();
    }
}

